// axios
import axios from 'axios'

const baseURL = 'https://stg-api.geteostre.com/api' // process.env.VUE_APP_BASE_API

const service = axios.create({
  baseURL
  // You can add your headers here
});

service.interceptors.request.use(
  config => {
    const url = config.url.toLowerCase();
    if (url.match(/(s3-|s3\.)?(.*)\.amazonaws\.com/) && url.indexOf('x-amz-credential') >= 0) {
      return config;
    }

    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }

    return config;
  },
  error => {
    console.error(error); // for debug
    Promise.reject(error);
  },
);

export default service;
